import { render } from "./ArrowMenuLeft.vue?vue&type=template&id=11971c19"
import script from "./ArrowMenuLeft.vue?vue&type=script&lang=js"
export * from "./ArrowMenuLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__